const initialState = {
  responseAgeGroupList: {},
  responseAgeGroupDetail: null,
  responseCreate: null,
  responseUpdate: null,
  loading: false,
  error: null,
};

export default function ageGroupReducer(state = initialState, action) {
  switch (action.type) {

    // LISTADO

    case 'AGE_GROUP_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'AGE_GROUP_RESPONSE':
      return {
        ...state,
        loading: false,
        responseAgeGroupList: action.value,
      };

    case 'AGE_GROUP_ERROR':
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // DETALLE

    case 'AGE_GROUP_DETAIL_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'AGE_GROUP_DETAIL_RESPONSE':
      return {
        ...state,
        loading: false,
        responseAgeGroupDetail: action.value,
      };

    case 'AGE_GROUP_DETAIL_ERROR':
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    //   CREATE

    case 'AGE_GROUP_CREATE_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
        responseCreate: null,
      };

    case 'AGE_GROUP_CREATE_RESPONSE':
      return {
        ...state,
        loading: false,
        responseCreate: action.value,
      };

    case 'AGE_GROUP_CREATE_ERROR':
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    //UPDATE

    case 'AGE_GROUP_UPDATE_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
        responseUpdate: null,
      };

    case 'AGE_GROUP_UPDATE_RESPONSE':
      return {
        ...state,
        loading: false,
        responseUpdate: action.value,
      };

    case 'AGE_GROUP_UPDATE_ERROR':
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case 'AGE_GROUP_CLEAR_STATE':
      return {
        ...state,
        error: null,
        responseCreate: null,
        responseUpdate: null,
      };

    /* ========================= */

    default:
      return state;
  }
}
